import styled from 'styled-components'

// TODO: fix height issue
const VerticalGridDivder = styled.div`
  margin: 0px;
  padding: 0px;
  display: grid;
  grid-template-rows: 7% 93%;
  width: 100%;
  height: 100%;
`

export default VerticalGridDivder
